import React, { useContext, useMemo } from 'react'

import { useSelector } from 'react-redux'

import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { OrderBy } from '../../../utils/constants'
import { getComment, getFullAbbreviation } from '../../../utils/entities/schoolSection'
import DataTable from '../../antd/Tables/DataTable/DataTable'
import { SchoolSectionModalContext } from '../../../Providers/Forms/SchoolSectionModal'

const SchoolSectionsTable = ({ loading, data, readOnly, metadata, parameters, onCreate, onParametersChange }) => {
  const { setFormHandler } = useContext(SchoolSectionModalContext)

  const t = useSelector(selectTranslate)

  const columns = useMemo(() => [
    { title: t('data_table.column_title.section'), orderBy: OrderBy.NAME, key: getFullAbbreviation },
    { title: t('data_table.column_title.comment'), key: getComment, style: { maxWidth: '200px' } }
  ], [t])

  return (
    <DataTable
      columns={columns}
      data={data}
      disabledAdd={readOnly}
      noDataMessage={t('common.no_data.section')}
      loading={loading}
      metadata={metadata}
      onCreate={() => setFormHandler({ data: [], callback: onCreate })}
      parameters={parameters}
      onParametersChange={onParametersChange}
    />
  )
}

export default SchoolSectionsTable
